<template>
<div class="subcribe-block d-flex justify-content-center align-items-center flex-column"
     :class="{'success':is_success}">
    <div class="subcribe-title">{{ formTitle }}</div>
    <form v-if="!is_success" class="subcribe-form" @submit.prevent="sendFormData">
        <div class="row w-100 m-0 gx-2">
            <template v-if="steps.active === 1">
                <div :class="{'bad-field':hasBadField('name')}"
                     class="col-12 col-md-2 mb-2 mb-md-4 mb-md-0 subcribe-form__wrapper-input">
                    <input
                        v-model="form.name"
                        aria-label="Имя"
                        class="form-control w-100 "
                        placeholder="Имя"
                        type="text">
                    <div v-if="hasBadField('name')" class="bad-field-text ">
                        Поле обязательно для заполнения
                    </div>
                </div>
                <div :class="{'bad-field':hasBadField('phone')}"
                     class="col-12 col-md-3 mb-2 mb-md-4 mb-md-0 subcribe-form__wrapper-input">
                    <input
                        v-model="form.phone"
                        v-phone
                        :aria-label="placeholder"
                        :placeholder="placeholder"
                        autocomplete="tel"
                        class="form-control w-100 "
                        max-length="14">
                    <div v-if="hasBadField('phone')" class="bad-field-text">
                        Поле обязательно для заполнения
                    </div>
                </div>
                <div :class="{'bad-field':hasBadField('city')}"
                     class="col-12 col-md-4 mb-2 mb-md-4 mb-md-0 subcribe-form__wrapper-input">
                    <input
                        v-model="form.city"
                        aria-label="Город"
                        @input="onCityInput"
                        class="form-control w-100 "
                        placeholder="Город"
                        type="text">
                    <ul v-if="suggestions.length" class="city-suggestions">
                        <li v-for="suggestion in suggestions"
                            :key="suggestion.id"
                            @click="selectCity(suggestion)"
                            v-html="highlightMatch(suggestion)">
                        </li>
                    </ul>
                    <div v-if="suggestions.length == 0 && form.city > 2" class="bad-field-text">
                        Город не найден
                    </div>
                    <div v-if="hasBadField('city')" class="bad-field-text ">
                        Поле Город, обязательно для заполнения и должно быть найдено в списке!
                    </div>
                </div>
                <div class="col">
                    <button>{{ button }}</button>
                </div>
                <div :class="{'bad-field':hasBadField('agreement')}" class="col-12 checkbox-politic mt-4">
                    <label class="checkbox-politic-label">
                        <input type="checkbox" v-model="this.agreement">
                        <div class="subscribe-span__wrapper">
                            <span> Вы даёте согласие на обработку персональных данных.</span>
                            <span class="subscribe-span_policy"> С Политикой обработки персональных данных Вы можете ознакомиться <a target="_blank" href="/kontakty/politika-konfidencialnosti/">здесь</a></span>
                        </div>
                    </label>
                </div>
            </template>
            <template v-if="steps.active === 2">
                <div class="select-step__wrapper row">
                    <div class="col-12 col-md-6 mb-2 mb-md-2 mb-md-0 px-1">
                        <div class="select-step"
                             @click="this.form.target='Запись на презентацию'"
                             :class="{active: this.form.target === 'Запись на презентацию' }">
                            Запись на презентацию
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mb-2 mb-md-2 mb-md-0 px-1 ">
                        <div class="select-step no-left-radius"
                             @click="this.form.target='Получить приз'"
                             :class="{active: this.form.target === 'Получить приз' }">
                            Получить приз
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mb-2 px-1">
                        <div class="select-step"
                             @click="this.form.target='Другой вопрос'"
                            :class="{active: this.form.target === 'Другой вопрос' }">
                            Другой вопрос
                        </div>
                    </div>
                    <div class="col-12 col-md-6 px-1 ">
                        <button>Отправить</button>
                    </div>
                </div>
            </template>
        </div>
    </form>
</div>
</template>

<script>
    import fn from "../../../js/fn";
    import PhoneMask from "../../vue-components/directives/PhoneMask";

    export default {
        name: "FormApp",
        directives: {
            'phone': PhoneMask
        },
        props: {
            title: {
                type: String,
                required: true
            },
            placeholder: {
                type: String,
                required: true
            },
            button: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                steps: {
                    active: 1,
                    titles: [
                        this.title,
                        'Уточните цель вашего обращения!'
                    ]
                },
                process: false,
                form: {
                    name: null,
                    phone: null,
                    city: null,
                    target: null,
                    url: window.location.href,
                },
                notifications: [],
                suggestions: [],
                agreement: false,
                is_success: false,
                is_city_selected: false
            }
        },
        computed: {
            formTitle() {
                return this.is_success ? 'Ваш запрос принят в работу!' : this.steps.titles[this.steps.active-1];
            }
        },
        methods: {
            onCityInput() {
                this.is_city_selected = false;
                this.fetchCities();
            },
            highlightMatch(city) {
                const query = this.form.city;
                const regex = new RegExp(`(${query})`, 'gi');
                return city.replace(regex, '<strong>$1</strong>');
            },
            async fetchCities() {
                if (this.form.city.length < 1) {
                    this.suggestions = [];
                    return;
                }

                fn.sync({
                    url: '/zen/project/api/cities:get',
                    data: {
                        city: this.form.city,
                    },
                    then: response => {
                        this.suggestions = response.cities;
                    },
                    error: error => {
                        this.suggestions = [];
                    }
                })
            },
            selectCity(city) {
                this.form.city = city;
                this.is_city_selected = true;
                this.suggestions = [];
            },
            resetForm() {
                this.form = {
                    name: null,
                    phone: null,
                    city: null,
                }
                this.agreement = false
                this.is_success = false
                this.steps.active = 1
            },
            async sendFormData() {
                if (this.process) {
                    return
                }

                this.notifications = []

                await this.checkField();

                if (this.notifications.length > 0) {
                    this.process = false;
                    return;
                }

                if (this.steps.active === 1) {
                    this.steps.active = 2
                    return
                }

                this.process = true

                fn.sync({
                    url: '/zen/project/api/subscribe:send',
                    data: {form: this.form},
                    then: response => {
                        this.process = false
                        this.notifications = response.notifications
                        if (response.success) {
                            this.is_success = true
                            setTimeout(() => {
                                this.resetForm();
                            }, 8000);
                        }
                    },
                    error: error => {
                        this.process = false
                    }
                })
            },
            async checkCityValidity() {
                if (!this.form.city) {
                    return false;
                }

                if (this.is_city_selected) {
                    this.is_city_selected = false; // Сбрасываем флаг
                    return true;
                }
                // Выполняем запрос на сервер для получения списка городов
                await this.fetchCities();

                // Проверяем, есть ли введенный город в списке предложений
                return this.suggestions.some(suggestion => suggestion.toLowerCase() === this.form.city.toLowerCase());
            },
            async checkField() {
                if (!this.agreement) {
                    this.notifications.push({
                        text: 'Не подтверждено согласие на обработку персональных данных',
                        type: 'danger',
                        field: 'agreement'
                    })
                }
                if (!this.form.name || this.form.name.length < 3) {
                    this.notifications.push({
                        text: 'Поле Имя, обязательно для заполнения!',
                        type: 'danger',
                        field: 'name'
                    })
                }
                // if (!this.form.city || this.form.city.length < 3) {
                //     this.notifications.push({
                //         text: 'Поле Город, обязательно для заполнения и должно быть найдено в списке!',
                //         type: 'danger',
                //         field: 'city'
                //     })
                // }

                let is_city_valid = await this.checkCityValidity();
                if (!is_city_valid) {
                    this.notifications.push({
                        text: 'Поле Город, обязательно для заполнения и должно быть найдено в списке!',
                        type: 'danger',
                        field: 'city'
                    });
                }

                if (!this.form.phone || this.form.phone.length !== 18) {
                    this.notifications.push({
                        text: 'Поле Телефон, обязательно для заполнения!',
                        type: 'danger',
                        field: 'phone'
                    })
                }
                if (!this.form.target && this.steps.active === 2) {
                    this.notifications.push({
                        text: 'Цель обращения, обязательно должно быть выбрано!',
                        type: 'danger',
                        field: 'target'
                    })
                }
            },
            hasBadField(field) {
                return !!this.notifications.find(notification => {
                    return notification.field === field
                })
            }
        }
    }
</script>

